import { observer } from "mobx-react-lite";
import ProposalsViewProposal from "./ProposalsViewProposal";
import ProposalAttachmentsTrigger from "./ProposalAttachmentsTrigger";
import { useProposalsViewStore } from "../ProposalsViewStore";
import { notNull } from "@gap/utils/utils";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Announcement from "features/main/main-router/org-guard/main-container/announcement/Announcement";


export default observer(function ProposalsViewAndSign() {
   const proposalsViewStore = useProposalsViewStore()
   const proposal = notNull(proposalsViewStore.proposal)

   return <Dialog fullScreen open>
      {proposalsViewStore.shouldShowPreviewAnnouncement && <Announcement type="info" announcementKey="proposalPreview" dismissible={false}>
         This is a preview only
      </Announcement>}
      <AppBar position="static" enableColorOnDark>
         <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1, color: 'inherit' }}>{proposalsViewStore.proposalTitle}</Typography>
            <ProposalAttachmentsTrigger proposal={proposal} />
            {proposalsViewStore.sp.orgGuardStore.org?.orgType === 'advisor' && <IconButton
               onClick={proposalsViewStore.closeProposalView}
               sx={{ color: 'inherit', ml: 1 }}
               aria-label="close"
            >
               <CloseIcon />
            </IconButton>}
         </Toolbar>
      </AppBar>
      <Box sx={{
         flex: 1,
         minHeight: 0,
         overflow: 'hidden',
         display: 'flex',
         flexDirection: 'column',
      }}>
         <ProposalsViewProposal {...{ proposal }} />
      </Box>
   </Dialog>
})
